// THE KC INDIA — Official Brand Data Lock (mirror of backend)
export const BRAND = {
  name: "THE KC INDIA",
  business: "Kedarnath Cottage",
  phone: "+91 6395960333",
  phoneDigits: "916395960333",
  whatsapp: "916395960333",
  email: "thekcindia@gmail.com",
  supportEmail: "kedarnathcottage@gmail.com",
  address: "Kedarnath Cottage, Near Heritage Aviation Helipad, Sersi, Rudraprayag, Uttarakhand – 246471, India",
  taglineEn: "Divine Experiences in the Heart of the Himalayas",
  taglineHi: "हिमालय की गोद में दिव्य अनुभव",
  mapEmbed: "https://www.google.com/maps?q=Kedarnath+Cottage+Sersi+Rudraprayag+Uttarakhand+246471&t=m&z=14&output=embed",
  googleMaps: "https://maps.app.goo.gl/cptPZafFD9JkABqb7",
  googlePlaceDataId: "0x3908490050fad87d:0x37d55f9d4ae17c0a",
  googleRating: 4.9,
  googleReviewCount: 74,
  startingRate: 3450,
};

export const whatsappLink = (msg = "Namaste 🙏 I would like to know more about THE KC INDIA.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

// Context-aware WhatsApp CTA — returns { label, message } based on current pathname.
// Used by the floating StickyActions button and in-page CTAs so the pre-filled
// WhatsApp text and the visible label both match what the guest is looking at.
export const WHATSAPP_CONTEXTS = [
  { test: (p) => /^\/stay(\/|$)/.test(p),                    label: "Ask About Room Availability",   message: "Namaste 🙏 I'd like to check room availability at Kedarnath Cottage. Please share options and pricing." },
  { test: (p) => /^\/book\/yatra/.test(p) || /^\/chardham/.test(p),
                                                              label: "Plan Your Kedarnath Yatra",     message: "Namaste 🙏 I'd like to plan a Kedarnath / Char Dham yatra with THE KC INDIA. Please guide me on packages, dates, and helicopter options." },
  { test: (p) => /^\/book\/wedding/.test(p) || /^\/weddings/.test(p),
                                                              label: "Talk to a Wedding Expert",      message: "Namaste 🙏 I'd like to plan a wedding at Triyuginarayan with THE KC INDIA. Please share the detailed packages and available dates." },
  { test: (p) => /^\/book\/anniversary/.test(p),              label: "Plan Your Celebration",         message: "Namaste 🙏 I'd like to plan an anniversary celebration at Triyuginarayan with THE KC INDIA. Please guide me on packages and add-ons." },
  { test: (p) => /^\/book\/event/.test(p),                    label: "Plan Your Celebration",         message: "Namaste 🙏 I'd like to plan an event / celebration with THE KC INDIA. Please share the available packages and dates." },
  { test: (p) => /^\/book\/transport/.test(p),                label: "Book Your Vehicle",             message: "Namaste 🙏 I'd like to book a vehicle / helicopter with THE KC INDIA. Please share pricing and availability." },
  { test: (p) => /^\/book(\/|$)/.test(p),                     label: "WhatsApp for Instant Booking",  message: "Namaste 🙏 I'd like to book a stay at Kedarnath Cottage. Please help me pick the right room and dates." },
  { test: (p) => /^\/contact/.test(p),                        label: "Chat with KC Concierge",        message: "Namaste 🙏 I'd like to chat with the KC Concierge team. My query is —" },
  { test: (p) => /^\/gallery/.test(p) || /^\/about/.test(p) || /^\/blog/.test(p),
                                                              label: "Chat with KC Concierge",        message: "Namaste 🙏 I'd like to know more about THE KC INDIA." },
];

export const whatsappContext = (pathname = "/") => {
  const ctx = WHATSAPP_CONTEXTS.find((c) => c.test(pathname));
  if (ctx) return { label: ctx.label, message: ctx.message, href: whatsappLink(ctx.message) };
  return { label: "WhatsApp Concierge", message: "Namaste 🙏 I would like to know more about THE KC INDIA.", href: whatsappLink() };
};

export const IMAGES = {
  heroKedarnath: "https://images.pexels.com/photos/14149541/pexels-photo-14149541.jpeg",
  himalayas: "https://images.unsplash.com/photo-1577516311194-eb14c570a137?auto=format&fit=crop&w=2000&q=80",
  bell: "https://images.unsplash.com/photo-1547452377-b2ac40e02ed6?auto=format&fit=crop&w=1400&q=80",
  roomLuxury: "https://images.unsplash.com/photo-1760067537116-de1f76fe8f95?auto=format&fit=crop&w=1600&q=80",
  roomBed: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1600&q=80",
  mandap: "https://images.unsplash.com/photo-1587271636175-90d58cdad458?auto=format&fit=crop&w=1600&q=80",
  weddingCouple: "https://images.unsplash.com/photo-1630526720753-aa4e71acf67d?auto=format&fit=crop&w=1600&q=80",
  chardham: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=1800&q=80",
  helicopter: "https://images.unsplash.com/photo-1547636780-e21f2a7b7b0e?auto=format&fit=crop&w=1400&q=80",
  food: "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?auto=format&fit=crop&w=1400&q=80",
  drone: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1800&q=80",
  river: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1600&q=80",
  temple: "https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?auto=format&fit=crop&w=1600&q=80",
  prayer: "https://images.unsplash.com/photo-1518709594023-6eab9bab7b23?auto=format&fit=crop&w=1400&q=80",
  cottage: "https://images.unsplash.com/photo-1587381420270-3e1a5b9e6904?auto=format&fit=crop&w=1600&q=80",
  gallery1: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1200&q=80",
  gallery2: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1200&q=80",
  gallery3: "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?auto=format&fit=crop&w=1200&q=80",
  gallery4: "https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?auto=format&fit=crop&w=1200&q=80",
};

export const ELEMENTS = [
  { name: "Earth",  meaning: "Stability", hi: "पृथ्वी" },
  { name: "Water",  meaning: "Purity",    hi: "जल" },
  { name: "Fire",   meaning: "Warmth",    hi: "अग्नि" },
  { name: "Air",    meaning: "Freedom",   hi: "वायु" },
  { name: "Sky",    meaning: "Infinity",  hi: "आकाश" },
];
